import {Utils} from './utils';

export class CsvExportUtils {
  public static exportCsv(csvData, csvExportName?, headerData?) {
    return Utils.exportCsv(csvData, csvExportName, headerData);
  }

  public static exportBlobCsv(csv, name?) {
    return Utils.exportBlobCsv(csv, name);
  }

  public static exportBlob(blobParts: any[], name?) {
    return Utils.exportBlobCsv(blobParts, name);
  }
}
